import {memo} from 'react';

import type {SVGProps} from 'react';

export const TrustDetailsIcon = memo(function TrustDetailsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M12.7272 4.1665H7.05051C6.37801 4.1665 5.83301 4.7115 5.83301 5.384V17.9486C5.83301 18.6215 6.37801 19.1665 7.05051 19.1665H16.2818C16.9547 19.1665 17.4997 18.6215 17.4997 17.949V8.96942C17.4997 8.74942 17.4126 8.53859 17.258 8.38234L13.3188 4.41275C13.1626 4.25525 12.9493 4.1665 12.7272 4.1665Z"
          fill="var(--icon-fill-blue)"
        />
        <path
          d="M5.20801 2.2915C4.51759 2.2915 3.95801 2.85109 3.95801 3.5415V16.4582C3.95801 17.1486 4.51759 17.7082 5.20801 17.7082H11.9413"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0202 17.7082H14.7915C15.4819 17.7082 16.0415 17.1486 16.0415 16.4582V6.87484H12.7081C12.0177 6.87484 11.4581 6.31525 11.4581 5.62484V2.2915H7.17188"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29199 9.7915H12.7087"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.25}
          strokeLinecap="round"
        />
        <path
          d="M7.29199 12.2915H12.7087"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.25}
          strokeLinecap="round"
        />
        <path
          d="M7.29199 14.7915H11.042"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.25}
          strokeLinecap="round"
        />
        <path
          d="M11.458 2.2915L14.3347 5.16817"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
